import QuestionnaireRequestAutomated from './QuestionnaireRequestAutomated'

export default QuestionnaireRequestAutomated
